// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"49":"component---src-pages-about-tsx","218":"component---src-pages-404-tsx","643":"component---src-pages-blog-index-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"49":"cd60ff848b666aa4137b","218":"2fb2eb1d7dd31410b7a2","643":"7a0b5a7165b7ba917b61","691":"24e377880dd531c4cbfe"}[chunkId] + ".js";
};